<div class="fdx-c-modal">

    <div class="fdx-c-modal__main fdx-c-modal__main--large">
        <div class="fdx-c-modal__body">
            <div class="fdx-c-modal__description">
                <h3 class="fdx-u-fontweight--bold fdx-u-align--center">
                    {{"SHIPMGNT.ShipdetailsPrintlabelTitle_Searchforprinter" | translate: {Default: "Search for Printer"} }}
                </h3>

                <div *ngIf="spinnerTableFlag" class="fdx-c-loading-indicator">
                    <div class="fdx-c-loading-indicator__part"></div>
                    <div class="fdx-c-loading-indicator__part"></div>
                    <div class="fdx-c-loading-indicator__part"></div>
                    <div class="fdx-c-loading-indicator__part"></div>
                </div>

                <!-- Container Input Box -->
                <form [formGroup]="searchPopupFormGroup">

                    <div class="fdx-o-grid__row fdx-o-grid__row--guttered-small fdx-o-grid__item--12 mt-5">

                        <div class="fdx-o-grid__item--12@large fdx-o-grid__item--12@medium fdx-o-grid__item--12">
                            <div class="fdx-c-form-group fdx-c-form-group--select fdx-c-form-group--has-value" [ngClass]="{
                                'fdx-c-form-group--is-invalid':
                                    !printerReq.valid &&
                                    printerReq.touched &&
                                    printerReq.hasError('required'),
                                'fdx-c-form-group--has-value':
                                    printerReq.value !== null && printerReq.value !== ''
                                }">
                                <span class="fdx-c-form-group__item" [ngClass]="{
                                    'fdx-c-form-group--is-invalid':
                                    !printerReq.valid &&
                                    printerReq.touched &&
                                    printerReq.hasError('required'),
                                    'fdx-c-form-group--has-value':
                                    printerReq.value !== null &&
                                    printerReq.value !== ''
                                }">

                                    <select id="printerReq" [formControl]="printerReq" class="fdx-c-form-group__select">
                                        <option label="{{ 'APP.AppOption_Select' | translate: {Default: 'Select'} }}" value="" selected="">
                                            {{"APP.AppOption_Select" | translate: {Default: "Select"} }}
                                        </option>
                                        <option *ngFor="let units of stationList" [value]="units">
                                            {{ units }}
                                        </option>
                                    </select>
                                    <div class="fdx-c-form-group__icon">
                                        <svg class="fdx-c-icon" aria-hidden="true" focusable="false" role="presentation">
                                            <use xlink:href="#chevron"></use>
                                        </svg>
                                    </div>
                                    <label class="fdx-c-form-group__label fdx-c-form-group__label__trunc" for="printerReq">
                                        {{"SHIPMGNT.ShipdetailsPrintlabelInput_Printrequestor" | translate: {Default: "Print Requestor"} }}
                                    </label>
                                </span>
                                <div role="alert" class="fdx-c-form-group__message fdx-c-form-message--error" *ngIf="
                    !printerReq.valid &&
                    printerReq.touched &&
                    printerReq.hasError('required')
                  ">
                                    {{"SHIPMGNT.ShipdetailsPrintlabelErrmsg_Pleaseselectaprintrequestor" | translate: {Default: "Please select a print requestor"} }}
                                </div>
                            </div>
                        </div>

                    </div>
                </form>
            </div>

            <!-- Action Buttons -->
            <div class="fdx-o-grid__item--12 fdx-u-align--right">
                <button class="fdx-c-button fdx-c-button--text" (click)="onClose('close')">
                    {{"APP.AppButton_Cancel" | translate: {Default: "CANCEL"} }}
                </button>
                <button [hidden]="showLoadingButtonSubmit" (click)="onSubmit()" class="fdx-c-button fdx-c-button--primary fxg-margin-right fdx-u-mt--8">
                    {{"APP.AppButton_Printlabel" | translate: {Default: "PRINT LABEL"} }}
                </button>
                <button [hidden]="!showLoadingButtonSubmit" class="fdx-c-button fdx-c-button--primary fdx-c-button--min-width fdx-c-button--loading loading-btn-post fdx-u-mt--8" aria-label="Continue">
                    <span class="fdx-c-button__title" hidden></span>
                    <span class="fdx-c-button__loading">
                        <div class="fdx-c-loading-indicator  fdx-c-loading-indicator--white">
                            <div class="fdx-c-loading-indicator__part"></div>
                            <div class="fdx-c-loading-indicator__part"></div>
                            <div class="fdx-c-loading-indicator__part"></div>
                            <div class="fdx-c-loading-indicator__part"></div>
                        </div>
                    </span>
                </button>
            </div>

        </div>
    </div>
</div>

<app-successmodal *ngIf="displaySuccessModal" [modalDialogBodyContent]="successContent" modalDialogType='MEDIUM' (closeSuccessModalDialogEvent)="handleCloseEventforSuccess()">
</app-successmodal>

<app-failure-modal *ngIf="displayFailureNotification" [modalDialogBodyContent]="errorMessage" modalDialogType='MEDIUM' (closeSuccessModalDialogEvent)="handleCloseErrorEvent()">
</app-failure-modal>